export const CANVAS_CONTAINER_ID = 'canvas-container'
export const POSITIONED_MEDIA_CONTROLS_HOST_CLASS_NAME =
  'positioned-media-controls-host'
